import { Button } from "@prosights/ui/components/button";
import { Input } from "@prosights/ui/components/input";
import { KeyRound, MoveRight } from "lucide-react";
import { type FormEvent, type ReactNode, useState } from "react";
import { api, clearApiKey, getApiKey, setApiKey } from "./api";

export function AuthGate({ children }: { children: ReactNode }) {
  const [authorized, setAuthorized] = useState(Boolean(getApiKey()));
  const [key, setKey] = useState("");
  const [error, setError] = useState("");
  const [pending, setPending] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setPending(true);
    setError("");
    setApiKey(key.trim());
    try {
      await api("/api/auth/me");
      setAuthorized(true);
    } catch (reason) {
      clearApiKey();
      setError(reason instanceof Error ? reason.message : "The API key was not accepted.");
    } finally {
      setPending(false);
    }
  }

  if (authorized) return children;

  return (
    <main className="auth-shell">
      <section className="auth-panel" aria-labelledby="access-title">
        <div className="brand-mark" aria-hidden="true">P</div>
        <div>
          <p className="eyebrow">ProSights Migrate</p>
          <h1 id="access-title">Enter the migration workbench</h1>
          <p className="muted copy">
            Use the shared workspace API key. It stays in this browser tab and is
            never written to project data.
          </p>
        </div>
        <form onSubmit={submit} className="auth-form">
          <label htmlFor="api-key">Workspace API key</label>
          <div className="key-field">
            <KeyRound size={15} aria-hidden="true" />
            <Input
              id="api-key"
              type="password"
              autoComplete="off"
              value={key}
              onChange={(event) => setKey(event.target.value)}
              placeholder="Paste API key"
              required
              autoFocus
            />
          </div>
          {error && <p className="form-error" role="alert">{error}</p>}
          <Button type="submit" disabled={pending || !key.trim()}>
            {pending ? "Checking…" : "Continue"}
            {!pending && <MoveRight size={15} />}
          </Button>
        </form>
        <p className="auth-footnote">
          Simulation only · External records remain read-only
        </p>
      </section>
    </main>
  );
}
